import { useFeature } from '../../services/features/reactBindings/hooks';
import { useAutoplaySlice } from '../../store/slices/autoplay/selectors';

export const useAutoplayHiddenFlag = (): boolean => {
  const removeAutoplay = useAutoplaySlice.shouldRemoveAutoplay();
  const disableAutoplay = useFeature('disableAutoplay');
  return removeAutoplay || disableAutoplay;
};
